<template>
  <form @submit="onSubmit">
    <BaseCard class="grid grid-cols-1 gap-4 md:grid-cols-2">
      <FormInputDatetime
        name="fromDatetime"
        label="Start Date"
      />
      <FormInputDatetime
        name="untilDatetime"
        label="End Date"
      />

      <FormInputMarkdown
        name="contents"
        label="Notification Content"
      />

      <div class="flex flex-col items-center justify-start">
        <FormFieldLabel> Preview </FormFieldLabel>
        <NotificationPreview
          :contents="values.contents || markdownPlaceholder"
        />
      </div>

      <div class="space-y-2">
        <FormInputCheckbox
          name="sendToTerminal"
          label="Send To Terminal"
        />
        <FormInputCheckbox
          name="sendToPortal"
          label="Send To Portal"
        />
      </div>

      <div class="col-span-full flex justify-end">
        <FormSubmitButton :is-loading="isSubmitting">
          Create Notification
        </FormSubmitButton>
      </div>
    </BaseCard>
  </form>
</template>

<script setup lang="ts">
import { useCreateNotificationForm } from "@/composables/forms/useCreateNotificationForm"

const router = useRouter()
const { handleSubmit, setErrors, isSubmitting, values } =
  useCreateNotificationForm()

const onSubmit = handleSubmit(async (formValues) => {
  try {
    await createNotification(formValues)
    router.push({
      name: "notificationIndex",
    })
  } catch (error) {
    if (error instanceof ApiError) {
      setErrors(error.requestErrors?.body ?? {})
      toast.error("Failed to create notification")
    } else if (error instanceof Error) {
      setErrors(JSON.parse(error.message))
    }
  }
})

const markdownPlaceholder = `
A preview of the content will display here.

Please write content using markdown syntax, a simple guide can be found at:

[https://www.markdownguide.org/cheat-sheet/](https://www.markdownguide.org/cheat-sheet/)
`
</script>
